// This file is auto-generated by @hey-api/openapi-ts

import type { AddExperienceToFavoritesResponse, GetFavoriteExperiencesResponse } from './types.gen';

export const addExperienceToFavoritesResponseTransformer = async (
  data: any,
): Promise<AddExperienceToFavoritesResponse> => {
  data.dt_created = new Date(data.dt_created);
  return data;
};

export const getFavoriteExperiencesResponseTransformer = async (data: any): Promise<GetFavoriteExperiencesResponse> => {
  data.data = data.data.map((item: any) => {
    item.dt_created = new Date(item.dt_created);
    return item;
  });
  return data;
};
